import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * MetaPixelTracker
 * Single Page Application (SPA) Route Tracker for Meta Pixel (Pixel ID: 1123614183532126).
 * Automatically fires PageView on every route change across the application.
 */
export default function MetaPixelTracker() {
  const location = useLocation();
  const isFirstMount = useRef(true);

  useEffect(() => {
    // The initial script in public/index.html already tracks the very first PageView on page load.
    // We only trigger PageView on subsequent client-side route transitions in React Router.
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }

    trackPixelEvent('PageView');
  }, [location.pathname, location.search]);

  return null;
}
